var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 139,
    viewBox: "0 0 207 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8162 0.231481C136.368 -2.34192 176.153 16.6572 198.948 51.4387C210.166 68.5483 207.501 75.347 196.08 91.0945C149.296 155.603 51.468 153.784 7.54036 87.275C-3.80516 70.0958 -1.31355 63.2334 10.2406 47.3525C29.7273 20.5579 61.4229 2.30063 94.8162 0.231481ZM96.5546 13.2724C66.8465 15.1155 38.5638 30.8283 21.1051 54.7366C18.8337 57.849 13.1088 65.83 13.1899 69.4177C13.2537 72.2577 17.2287 78.129 18.9322 80.656C52.0185 129.869 121.818 140.296 167.687 102.24C175.423 95.824 188.57 81.7573 192.337 72.5591C194.492 67.2848 190.28 62.0684 187.394 57.7794C167.432 28.0868 132.405 11.0467 96.5546 13.2724Z",
    fill: "#7BB88F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2938 29.3552C131.085 26.0167 154.372 60.1316 138.003 89.0708C122.729 116.08 83.1877 115.912 68.1685 88.7868C54.5516 64.1946 70.1618 32.2126 98.2938 29.3494V29.3552ZM100.032 42.396C65.6711 46.1228 70.2835 98.9471 105.548 96.165C140.593 93.4004 136.502 38.4432 100.032 42.396Z",
    fill: "#7BB88F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVisible);
export default __webpack_public_path__ + "static/media/ico-visible.1eadd0e61fb420ce72eeda340197c389.svg";
export { ForwardRef as ReactComponent };